/* eslint-disable no-case-declarations */
import { cloneDeep } from 'lodash';
import {
    FETCH_FEATURED_MATCH,
    FETCH_FEATURED_MATCH_SUCCESS,
    FETCH_FEATURED_MATCH_FAILURE,
} from '../actions/featured-matches-actions';

const _ = { cloneDeep };

const initialState = {
    isLoading: false,
    tournamentList: [],
    tournamentListLoaded: false,
    tournamentDetails: {},
    tournamentDetailsLoaded: false,
    allMatches: [],
    featuredMatches: [],
    heroImageDetails: {},
};

function updateMatch(array, index, updatedMatch) {
    const newArray = array.slice();
    const match = newArray[index];
    newArray[index] = {
        ...match,
        ...updatedMatch,
    };
    return newArray;
}

function updatePlayerImage(array, index, playerId, data) {
    const newArray = array.slice();
    const match = newArray[index];

    if (match.player1Id === playerId) {
        match.player1Image = `${data.url}?timestamp=${new Date().getTime()}`;
    } else if (match.player2Id === playerId) {
        match.player2Image = `${data.url}?timestamp=${new Date().getTime()}`;
    }

    newArray[index] = {
        ...match,
    };
    return newArray;
}

function app(state = initialState, action) {
    switch (action.type) {
        case 'TOURNAMENT_CONTENT:FETCH_TOURNAMENT_LIST_REQUEST':
            return {
                ...state,
                tournamentListLoaded: false,
            };
        case 'TOURNAMENT_CONTENT:FETCH_TOURNAMENT_LIST_SUCCESS':
            return {
                ...state,
                tournamentList: action.data,
                tournamentListLoaded: true,
            };
        case 'TOURNAMENT_CONTENT:FETCH_TOURNAMENT_DETAIL_REQUEST':
            return {
                ...state,
                tournamentDetailsLoaded: false,
            };
        case 'TOURNAMENT_CONTENT:FETCH_TOURNAMENT_DETAIL_SUCCESS':
            return {
                ...state,
                tournamentDetails: action.data,
                tournamentDetailsLoaded: true,
            };
        case 'TOURNAMENT_CONTENT:SAVE_TOURNAMENT_DETAIL_REQUEST':
            return {
                ...state,
                tournamentDetailsLoaded: false,
            };
        case 'TOURNAMENT_CONTENT:SAVE_TOURNAMENT_DETAIL_SUCCESS':
            return {
                ...state,
                tournamentDetails: action.data,
                tournamentDetailsLoaded: true,
            };

        case 'TOURNAMENT_CONTENT:FETCH_ALL_MATCHES_SUCCESS':
            return {
                ...state,
                allMatches: action.data,
            };
        case 'TOURNAMENT_CONTENT:FETCH_MATCH_DETAILS_SUCCESS':
            let matchRows;
            switch (action.matchType) {
                case 'all':
                    matchRows = _.cloneDeep(state.allMatches);
                    matchRows[action.index].data = action.data;
                    return {
                        ...state,
                        allMatches: matchRows,
                    };
                case 'featured':
                    matchRows = _.cloneDeep(state.featuredMatches);
                    matchRows[action.index].data = action.data;
                    return {
                        ...state,
                        featuredMatches: matchRows,
                    };
                default:
                    return {
                        ...state,
                    };
            }
        case 'TOURNAMENT_CONTENT:SAVE_ALL_MATCHES_SUCCESS':
            return {
                ...state,
                allMatches: action.data,
            };

        case 'TOURNAMENT_CONTENT:FETCH_FEATURED_MATCHES_SUCCESS':
            return {
                ...state,
                featuredMatches: action.data,
            };
        case FETCH_FEATURED_MATCH:
            return {
                ...state,
                featuredMatches: updateMatch(state.featuredMatches, action.index, { isLoading: true }),
            };
        case FETCH_FEATURED_MATCH_SUCCESS:
            return {
                ...state,
                featuredMatches: updateMatch(state.featuredMatches, action.index, { isLoading: false, data: action.data }),
            };
        case FETCH_FEATURED_MATCH_FAILURE:
            return {
                ...state,
                featuredMatches: updateMatch(state.featuredMatches, action.index, { isLoading: false, data: null, error: action.data || 'An error occurred' }),
            };
        case 'TOURNAMENT_CONTENT:SAVE_FEATURED_MATCHES_SUCCESS':
            return {
                ...state,
                featuredMatches: action.data,
            };

        case 'TOURNAMENT_CONTENT:UPLOAD_PLAYER_IMAGE_SUCCESS':
            return {
                ...state,
                featuredMatches: updatePlayerImage(state.featuredMatches, action.index, action.playerId, action.data),
            };

        case 'TOURNAMENT_CONTENT:UPDATE_PLAYER_IMAGE_CSS':
            const { index, screen, position, type, value } = action.data;
            const match = _.cloneDeep(state.featuredMatches[index]);
            let positionStyle = '';
            let screenStyle = '';
            let transform = '';
            let newTransform = '';
            let rotate = '';
            let scale = '';

            switch (position) {
                case 'left':
                    positionStyle = 'Left';
                    break;
                case 'right':
                    positionStyle = 'Right';
                    break;
                default:
                    break;
            }

            switch (screen) {
                case 'desktop':
                    screenStyle = 'large';
                    break;
                case 'mobile':
                    screenStyle = 'small';
                    break;
                default:
                    break;
            }

            if (!match[`${screenStyle}${positionStyle}ImageStyle`]) {
                match[`${screenStyle}${positionStyle}ImageStyle`] = {};
            }
            if (!match[`${screenStyle}${positionStyle}Style`]) {
                match[`${screenStyle}${positionStyle}Style`] = {};
            }

            switch (type) {
                case 'height':
                    match[`${screenStyle}${positionStyle}ImageStyle`].height = `${value}px`;
                    break;
                case 'left':
                    match[`${screenStyle}${positionStyle}Style`].left = `${value}px`;
                    break;
                case 'right':
                    match[`${screenStyle}${positionStyle}Style`].right = `${value}px`;
                    break;
                case 'bottom':
                    match[`${screenStyle}${positionStyle}Style`].bottom = `${value}px`;
                    break;
                case 'rotate':
                    ({ transform } = match[`${screenStyle}${positionStyle}Style`]);
                    if (transform) {
                        transform = transform.split(' ');
                        scale = 1;
                        rotate = 0;
                        transform.forEach((item) => {
                            if (item.indexOf('scale') !== -1) {
                                scale = item.match(/\(([^)]+)\)/);
                                scale = scale && scale.length > 0 ? parseFloat(scale[1]) : null;
                            }
                            if (item.indexOf('rotateY') !== -1) {
                                rotate = item.match(/\(([^)]+)\)/);
                                rotate = rotate && rotate.length > 0 ? parseFloat(rotate[1]) : null;
                            }
                        });
                        newTransform = `scale(${scale}) rotateY(${value}deg)`;
                        match[`${screenStyle}${positionStyle}Style`].transform = newTransform;
                    } else {
                        match[`${screenStyle}${positionStyle}Style`].transform = `rotateY(${value}deg)`;
                    }
                    break;
                case 'scale':
                    ({ transform } = match[`${screenStyle}${positionStyle}Style`]);
                    if (transform) {
                        transform = transform.split(' ');
                        scale = 1;
                        rotate = 0;
                        transform.forEach((item) => {
                            if (item.indexOf('scale') !== -1) {
                                scale = item.match(/\(([^)]+)\)/);
                                scale = scale && scale.length > 0 ? parseFloat(scale[1]) : null;
                            }
                            if (item.indexOf('rotateY') !== -1) {
                                rotate = item.match(/\(([^)]+)\)/);
                                rotate = rotate && rotate.length > 0 ? parseFloat(rotate[1]) : null;
                            }
                        });
                        newTransform = `scale(${value}) rotateY(${rotate}deg)`;
                        match[`${screenStyle}${positionStyle}Style`].transform = newTransform;
                    } else {
                        match[`${screenStyle}${positionStyle}Style`].transform = `scale(${value})`;
                    }
                    break;
                default:
                    break;
            }

            return {
                ...state,
                featuredMatches: updateMatch(state.featuredMatches, index, match),
            };
        case 'TOURNAMENT_CONTENT:UPDATE_HERO_IMAGE_CSS':
            const heroType = action.data.type;
            const heroValue = action.data.value;
            const heroImageDetails = _.cloneDeep(state.heroImageDetails);

            if (!heroImageDetails.overlayStyle) {
                heroImageDetails.overlayStyle = {};
            }

            switch (heroType) {
                case 'overlayStyleCss':
                    heroImageDetails.overlayStyle[`${heroType}`] = `${heroValue || 0}`;
                    break;
                default:
                    break;
            }

            return {
                ...state,
                heroImageDetails,
            };
        case 'TOURNAMENT_CONTENT:CANCEL_PLAYER_IMAGE_CSS':
            return {
                ...state,
                featuredMatches: updateMatch(state.featuredMatches, action.index, action.data),
            };
        case 'TOURNAMENT_CONTENT:FETCH_HERO_IMAGE_DETAILS_REQUEST':
            return {
                ...state,
                tournamentDetailsLoaded: false,
            };
        case 'TOURNAMENT_CONTENT:FETCH_HERO_IMAGE_DETAILS_REQUEST_SUCCESS':
            return {
                ...state,
                tournamentDetailsLoaded: true,
                heroImageDetails: action.data,
            };
        case 'TOURNAMENT_CONTENT:SAVE_HERO_IMAGE_REQUEST_SUCCESS':
            return {
                ...state,
                heroImageDetails: action.data,
            };
        case 'TOURNAMENT_CONTENT:SAVE_HERO_IMAGE_DETAILS_REQUEST_SUCCESS':
            return {
                ...state,
            };
        default:
            return state;
    }
}

export default app;
